'use strict'

import ModalPlan from '@ui/Modal/Plan/component'
import { initZoomMediasPanel } from 'assets/core/js/page/product/zoomMediasPanel'

import type { ModalType } from '@ui/Modal/component'

const initModalPlan = (): void => {
  const planButtonEl = document.querySelector<HTMLButtonElement>('.presentation__plan-button')

  if (!planButtonEl) {
    return
  }

  const id = planButtonEl.getAttribute('data-modal-target')

  if (!id) {
    return
  }

  let modal: ModalType | undefined

  planButtonEl.addEventListener('click', () => {
    if (!modal) {
      modal = ModalPlan(id)
    }

    modal?.open()
  })
}

const initVideoOpen = (): void => {
  const videoEl = document.querySelector<HTMLImageElement>('.presentation__video img')

  if (!videoEl) {
    return
  }

  initZoomMediasPanel(videoEl, true)
}

export default (): void => {
  const presentationEl = document.querySelector('.product__presentation')

  if (!presentationEl) {
    return
  }

  const observer = new window.IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        initModalPlan()

        observer.unobserve(entry.target)
      }
    })
  })

  observer.observe(presentationEl)

  initVideoOpen()
}
